export default "__VITE_ASSET__BfQE7RMY__"